// How often a Focus queue re-reads the server. Each poll downloads 1 to 1.7 MB
// and costs the server most of a second per seller, so the base is a minute.
// The jitter spreads sellers who opened Focus together across the window
// instead of letting them poll in lockstep.

export const FOCUS_POLL_MS = 60_000
export const FOCUS_POLL_JITTER_MS = 10_000

/** `base` give or take up to `jitter`, in whole milliseconds. */
export function jitteredInterval(base: number, jitter: number, random: () => number = Math.random): number {
  return Math.round(base + (random() * 2 - 1) * jitter)
}
